<template>
    <div
        class="modal fade"
        id="weaponAbilityCompendiumModal"
        tabindex="-1"
        aria-hidden="true"
        ref="modal"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h4 class="modal-title">
                        {{
                            mode === "add"
                                ? "Add Weapon Ability"
                                : "Edit Weapon Ability"
                        }}
                    </h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                    ></button>
                </div>

                <div class="modal-body">
                    <!-- Edit: pick existing -->
                    <div v-if="mode === 'edit'" class="input-group mb-3">
                        <span class="input-group-text">Select Ability</span>
                        <select
                            v-model="selectedName"
                            @change="loadAbility"
                            class="form-select"
                        >
                            <option disabled value="">Select...</option>
                            <option
                                v-for="a in store.weaponAbilities.sort((a, b) =>
                                    a.name.localeCompare(b.name)
                                )"
                                :key="a.name"
                                :value="a.name"
                            >
                                {{ a.name }}
                            </option>
                        </select>
                    </div>

                    <!-- Ability form -->
                    <div class="input-group mb-3">
                        <span class="input-group-text">Name</span>
                        <input
                            v-model="ability.name"
                            type="text"
                            class="form-control"
                        />
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text">Description</span>
                        <textarea
                            v-model="ability.description"
                            class="form-control"
                        ></textarea>
                    </div>
                </div>

                <p class="px-3">
                    <strong
                        >Note: These changes won't affect any weapons currently
                        added to your character. You will need to remove and
                        re-add the weapon for the changes to take
                        effect.</strong
                    >
                </p>

                <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal">
                        <font-awesome-icon
                            icon="multiply"
                            class="me-1"
                        /><font-awesome-icon
                            icon="multiply"
                            class="me-1"
                        />Close
                    </button>
                    <button
                        v-if="mode === 'edit'"
                        class="btn btn-danger me-1"
                        @click="deleteAbility"
                        data-bs-dismiss="modal"
                    >
                        <font-awesome-icon
                            icon="trash-alt"
                            class="me-1"
                        />Delete
                    </button>
                    <button
                        class="btn btn-primary"
                        @click="saveAbility"
                        data-bs-dismiss="modal"
                    >
                        <font-awesome-icon icon="save" class="me-1" />Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRosterStore } from "@/stores/index";

export default {
    name: "WeaponAbilityCompendiumModal",
    props: { mode: { type: String, default: "add" } },
    data() {
        return {
            store: useRosterStore(),
            selectedName: "",
            ability: { name: "", description: "" },
        };
    },
    mounted() {
        this.$refs.modal.addEventListener("show.bs.modal", () => {
            this.resetForm();
        });
    },
    methods: {
        resetForm() {
            this.selectedName = "";
            this.ability = { name: "", description: "" };
        },
        loadAbility() {
            const found = this.store.weaponAbilities.find(
                (a) => a.name === this.selectedName
            );
            if (found) this.ability = JSON.parse(JSON.stringify(found));
        },
        saveAbility() {
            if (!this.ability.name.trim()) {
                alert("Ability must have a name!");
                return;
            }
            if (!this.ability.description.trim()) {
                alert("Ability must have a description!");
                return;
            }

            if (this.mode === "add") {
                this.store.weaponAbilities.push(this.ability);
            } else {
                const idx = this.store.weaponAbilities.findIndex(
                    (a) => a.name === this.selectedName
                );
                if (idx !== -1)
                    this.store.weaponAbilities.splice(idx, 1, this.ability);
            }
        },
        deleteAbility() {
            if (!this.selectedName) return;
            if (confirm(`Delete ability "${this.selectedName}"?`)) {
                const idx = this.store.weaponAbilities.findIndex(
                    (a) => a.name === this.selectedName
                );
                if (idx !== -1) this.store.weaponAbilities.splice(idx, 1);
            }
        },
    },
};
</script>

